import signedFetch, { JSON_HEADERS } from '../util/signedFetch.js';

export default ({ orgId, classId }) => {
  const URL = `${__API_BASE__}/org/${orgId}/placementTest/${classId}/access`;

  return signedFetch('userAccessPlacementTest', URL, 'POST', undefined, JSON_HEADERS, false, false, true, true);
};
